import React from 'react'

import Iframe from 'react-iframe'

import {
  MercariEvent,
} from '../../constants'

import { Message, EE, Events } from '../../message'

/**
  * We can pass data from this iframe to this component by:
    1) fetching the data via a content script that loads within the iframe on Mercari.com
    2) this content script passes the data to the background script of the extension
    3) the data is passed to the content script of listingjoy
    4) the listing joy content script dispatches an event on the window.document with the data (and this component is listing for that event)

    more reading: 
      https://developer.chrome.com/extensions/messaging#external-webpage
      https://developer.chrome.com/extensions/manifest/externally_connectable
 */
class ListingsFetcherMercari extends React.Component {

  constructor(props) {
    super(props)

    this.onReceiveListings = this.onReceiveListings.bind(this)
  }

  componentDidMount() {
    document.addEventListener(MercariEvent.RECEIVE.GET_LISTINGS, this.onReceiveListings)
  }

  componentWillUnmount() {
    document.removeEventListener(MercariEvent.RECEIVE.GET_LISTINGS, this.onReceiveListings)
  }

  onReceiveListings(e) {

    let items = e.detail.data || []
    console.log('Received listings from mercari: ', items)

    if (this.props.onReceiveListings) {
      this.props.onReceiveListings(items, 'mercari')
    }

    EE.emitEvent(Events.ListingsFetcherMercari.DID_GET_LISTINGS, [items, 'mercari'])
  }

 /* Need to pass data as follows:
   1) this code to background
   2) background to content script iframeLoaded in mercari
   3) content script back to background
   4) background back listingjoy content script
   5) LJ content script dispatches an event that we are listening for in this component */
  render() {
    return (
      <Iframe 
        id='iframe-mercari-listings'
        url={`https://www.mercari.com/mypage/listings/active?${MercariEvent.SEND.GET_LISTINGS}=1`}
        width={400} 
        height={800}
        display='initial' 
        position='absolute'
      />
    )
  }
}

export default ListingsFetcherMercari